(() => {
  const warsawYear = (now) => Number(new Intl.DateTimeFormat('en', {timeZone:'Europe/Warsaw', year:'numeric'}).format(now));
  // Midnight on 24 December in Poland: December is UTC+1.
  const christmasTarget = (year) => Date.UTC(year, 11, 23, 23, 0, 0);
  const update = (root, now = new Date()) => {
    const remaining = Math.max(0, Math.floor((christmasTarget(warsawYear(now)) - now.getTime()) / 1000));
    const values = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
    ['days','hours','minutes','seconds'].forEach((key, index) => {
      const node = root.querySelector(`[data-pc-${key}]`);
      if (node) node.textContent = index === 0 ? String(values[index]) : String(values[index]).padStart(2, '0');
    });
    const clock = root.querySelector('[role="timer"]');
    if (clock) clock.setAttribute('aria-label', `Do 24 grudnia zostało: ${values[0]} dni, ${values[1]} godzin, ${values[2]} minut, ${values[3]} sekund`);
  };
  const init = () => document.querySelectorAll('[data-pc-holiday]').forEach((root) => {
    if (root.dataset.pcClockReady) return;
    root.dataset.pcClockReady = 'true';
    update(root);
    const interval = setInterval(() => {
      if (!root.isConnected) { clearInterval(interval); return; }
      update(root);
    }, 1000);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
